var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _rect2, _path26, _path27, _path28, _path29, _path30, _path31, _path32;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirectMailDisabled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 299,
    height: 182,
    viewBox: "0 0 299 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 299,
    height: 182,
    fill: "#F9F9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M154 181.011H280",
    stroke: "#273754"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M217.759 101.925V180.468",
    stroke: "#273754"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M155 43.5386C155 43.5386 164.218 51.0875 165.819 53.4287C165.819 53.4287 171.523 44.3694 174.225 45.5909C176.927 46.8124 179.729 49.4589 178.828 49.6625C177.927 49.8661 176.527 49.3571 176.527 49.3571C176.527 49.3571 176.238 52.6144 174.631 52.4108",
    stroke: "#273754"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M157.286 80.4543C157.286 80.4543 161.441 146.325 149.704 177.513L152.156 181.011H131.281C131.281 181.011 129 97.2269 129 79.1431L157.286 80.4543Z",
    fill: "#526181"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M130 154.448L154.108 132.55C154.108 132.55 154.855 132.934 156 133.606C155.563 140.736 154.911 147.92 153.964 154.733C143.097 156.151 130 154.448 130 154.448H130Z",
    fill: "#273754"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M146.624 122.156L145.633 75.187L162.112 83.5932C162.112 83.5932 179.959 127.84 165.073 140.106C150.186 152.372 123.823 154.167 123.823 154.167L120.412 159.253L117 136.815L146.624 122.156Z",
    fill: "#526181"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M117 137.495L147 122.66",
    stroke: "#273754"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M161.38 82.1104C161.38 82.1104 178.722 127.777 164.21 140.138C149.698 152.499 124 154.308 124 154.308",
    stroke: "#273754"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M149 27.9248V36.8615L138 39.5825V24.5013L149 21.7803V27.9248Z",
    fill: "#E2E2FC"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M143.5 30.6814C143.776 30.6814 144 30.46 144 30.1869C144 29.9138 143.776 29.6924 143.5 29.6924C143.224 29.6924 143 29.9138 143 30.1869C143 30.46 143.224 30.6814 143.5 30.6814Z",
    fill: "#273754"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M147.5 30.6814C147.776 30.6814 148 30.46 148 30.1869C148 29.9138 147.776 29.6924 147.5 29.6924C147.224 29.6924 147 29.9138 147 30.1869C147 30.46 147.224 30.6814 147.5 30.6814Z",
    fill: "#273754"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M146 32.6594V27.7144H149",
    stroke: "#273754"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M143 27.7144H145",
    stroke: "#273754"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M138.72 23.9673V25.5552C137.853 25.5552 137.149 24.8609 137.149 24.0043C137.149 23.9567 137.152 23.9097 137.156 23.8632C137.244 22.9001 138.72 23.0004 138.72 23.9673Z",
    fill: "#E2E2FC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M139 31.6704C138.448 31.6704 138 30.7848 138 29.6924",
    stroke: "#273754"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M145 35.6265C143.895 35.6265 143 34.7409 143 33.6484",
    stroke: "#526181",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M149 36.6157L138 39.5828",
    stroke: "#273754"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M146 32.6597H145",
    stroke: "#273754",
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M139 29.6924C139 29.6924 140.465 28.5794 140.398 25.7363H149",
    stroke: "#273754"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M149.696 26.64C149.696 26.64 151.848 25.5095 150.623 21.2139C150.623 21.2139 141.099 19.2114 138.275 23.9269L137.765 22.2151C137.765 22.2151 133.137 29.8698 138.87 33.6486",
    stroke: "#273754"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M129 54.8462V78.0033L163 86.0663V60.2756C163 51.1306 156.529 43.1672 147.325 40.9845C142.911 39.9377 138.244 40.9068 134.667 43.6126C131.089 46.3184 129 50.4606 129 54.8462Z",
    fill: "#E2E2FC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M160 65.679L164.73 47.4946C164.73 47.4946 174.054 48.4086 176.081 54.0233C176.081 54.0233 180.541 51.0201 185 52.1952L177.567 71.6505L165.627 74.1979",
    fill: "#526181"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M132.812 44.5278C132.812 44.5278 121.15 54.4209 128.343 75.6775C135.537 96.9341 173.49 72.0053 172.995 65.2523C172.673 60.852 167.641 64.2976 167.641 64.2976C167.641 64.2976 167.516 61.6278 166.565 63.1876C166.086 63.9233 165.683 64.7053 165.361 65.5217L143.665 65.6585L143.604 55.9102",
    stroke: "#273754"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M173.972 69.2529C173.972 69.2529 175.163 82.1755 162 81.0518",
    stroke: "#273754"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M20 181.011H152",
    stroke: "#273754"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M126.798 179.975C126.798 179.975 128.412 177.156 124.316 176.543C121.882 176.172 119.392 176.469 117.118 177.401C117.118 177.401 119.972 173.97 115.504 172.499C111.036 171.029 106.444 174.46 106.444 174.46C106.444 174.46 110.912 166.25 107.437 165.637C103.962 165.024 102.1 168.578 102.1 168.578C102.1 168.578 102.472 158.407 95.2737 158.162C88.0751 157.916 88.8198 171.151 88.8198 171.151C88.8198 171.151 85.717 165.269 80.5042 165.024C75.2915 164.779 77.8979 174.877 77.8979 174.877C77.8979 174.877 76.9049 172.499 73.4298 172.254C69.9546 172.009 70.2028 174.885 70.2028 174.885C70.2028 174.885 65.7348 168.7 60.7702 169.068C55.8057 169.436 57.9156 175.563 57.9156 175.563C52.827 175.195 51.71 180.702 51.71 180.702H130.398L126.798 179.975Z",
    fill: "#273754"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M210.301 72.5952C218.083 72.5952 224.391 78.7943 224.391 86.4412V102.407H196.211V86.4412C196.211 78.7943 202.519 72.5952 210.301 72.5952Z",
    fill: "#0B2456"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 200.236,
    y: 85.939,
    width: 20.1288,
    height: 1.00536,
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M217.345 62.8302L199.48 78.1529C212.816 67.1004 224.138 79.409 224.138 85.94L224.39 103.523L238.983 90.2101V70.8683C238.228 62.3279 223.383 57.3041 217.345 62.8302Z",
    fill: "#E2E2FC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M224.389 102.407V86.7075C224.389 79.188 218.068 73.0923 210.271 73.0923C205.801 73.0923 201.815 75.0958 199.229 78.2224",
    stroke: "#0B2456"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5856 17.6816H79.5856C94.1999 17.6816 106.047 29.3792 106.047 43.8089V73.9365H53.124V43.8089C53.124 29.3792 64.9713 17.6816 79.5856 17.6816V17.6816Z",
    fill: "#E2E2FC"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M53 74.1978V42.9064C53 35.7093 55.8446 30.8615 60.9081 25.7724C65.9716 20.6832 72.8392 17.8242 80 17.8242",
    stroke: "#273754"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5844 12.8794V78.7387",
    stroke: "#273754"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M112.936 45.8095H46.2344",
    stroke: "#273754"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M196.211 102.771H195.711V103.771H196.211V102.771ZM224.14 103.271V103.771H224.331L224.473 103.643L224.14 103.271ZM239.318 90.3302C239.524 90.1459 239.541 89.8298 239.357 89.6242C239.172 89.4186 238.856 89.4014 238.651 89.5858L239.318 90.3302ZM196.211 103.771H224.14V102.771H196.211V103.771ZM224.473 103.643L239.318 90.3302L238.651 89.5858L223.806 102.899L224.473 103.643Z",
    fill: "#0B2456"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectMailDisabled);
export default __webpack_public_path__ + "static/media/direct-mail-disabled.5a48106af93e72f041bc588f1755522f.svg";
export { ForwardRef as ReactComponent };